const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://izc72q2twf.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://aeu7ydxcql.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://mqfvsp42gl.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.staging.evolution.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://gyaxuutzbl.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;